// extracted by mini-css-extract-plugin
module.exports = {"details":"DetailedSummary_details__JglwO","type":"DetailedSummary_type__6TI94","value":"DetailedSummary_value__SgeT0","toggle":"DetailedSummary_toggle__Aety1"};